import { videoVoClient } from '../../utils/zonesClient';

export interface IVideoVoRule {
  comment?: string | null;
  fulfilled?: boolean;
  undetermined?: boolean;
}

export interface IVideoVoResponse {
  success?: boolean;
  data?: {
    nid?: string;
    country?: string;
    // Cada país expone sus propias reglas bajo esta llave.
    'variables-approbology'?: Record<string, Record<string, unknown>>;
  };
}

export const getVideoVoResults = async ({
  nid,
  country,
}: {
  nid: string;
  country: string;
}): Promise<IVideoVoResponse> => {
  const { data } = await videoVoClient.get('video_vo_results', {
    params: { nid, country },
  });
  return data;
};
